function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, HTMLAttributes } from 'react';
import { ProductInformer } from './ProductInformer';
export const ProductInformerExpiration = rest => {
  return /*#__PURE__*/React.createElement(ProductInformer, _extends({
    iconName: "timeRound",
    iconColor: "#FF1F78",
    color: "#FF1F78"
  }, rest), "\u0413\u043E\u0434\u0435\u043D \u043C\u0435\u043D\u0435\u0435 3 \u043C\u0435\u0441\u044F\u0446\u0435\u0432");
};